import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Trash2 } from "lucide-react";
import { useDeleteAmenity } from "@/components/pages/amenities/hooks/amenities.hooks";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

type Props = {
  amenityId: string;
};

export const AmenityDeleteButton: React.FC<Props> = ({ amenityId }) => {
  const [open, setOpen] = useState(false);
  const { mutateAsync: deleteAmenity, isPending } = useDeleteAmenity();
  const { t } = useTranslation();
  const onConfirm = async () => {
    try {
      await deleteAmenity(amenityId);
      setOpen(false);
    } catch (e) {
      console.error(e);
      toast(t("amenities.delete.error"));
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button
          variant="new_ghost"
          size="icon_sm"
          title={t("amenities.delete.delete")}
        >
          <Trash2 />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("amenities.delete.title")}</DialogTitle>
          <DialogDescription>{t("amenities.delete.confirm")}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="new_outline" disabled={isPending}>
              {t("amenities.delete.cancel")}
            </Button>
          </DialogClose>
          <Button
            variant="new_destructive"
            onClick={onConfirm}
            disabled={isPending}
          >
            {isPending
              ? t("amenities.delete.deleting")
              : t("amenities.delete.delete")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AmenityDeleteButton;
